import { apiObject } from 'index';


export type FreshpaintEvent = {
  eventName: string;
  payload: apiObject;
};


const { freshpaint } = window;


export const track = (event: FreshpaintEvent) => {
  if (typeof freshpaint === 'undefined') {
    return;
  }

  try {
    freshpaint.track(event.eventName, event.payload);
  } catch (error) {
    console.error('Freshpaint tracking error:', error);
  }
};


export const makeTrackingFunction = <T extends FreshpaintEvent>(eventName: T['eventName']) =>
  (payload: T['payload']) => {
    track({
      eventName,
      payload
    });
  };
